<template>
  <v-carousel cycle height="70" hide-delimiters show-arrows-on-hover class="primary">
    <v-carousel-item v-for="(platUse, index) in platUses" :key="index">
      <v-sheet class="fill-height" color="rgba(255, 255, 255, 0.2)">
        <v-row class="fill-height align-center justify-center ma-0">
          <v-col 
            cols="12" 
            class="text-center primary--text text--darken-4 px-10 text-caption text-sm-body-1 font-weight-medium"
          >
            {{ platUse }}
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: 'VCarouselUses',
  props: ['platUses'],
};
</script>
